import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="--spacing4 --transparent" type={"SiteHeader"} item={{"color":"rgba(255,255,255,1)","colorHover":"rgba(255,255,255,0.5)","className":"fs--18 w--500 ls--002"}} title={{"color":"rgba(255,255,255,1)","content":"Název webu","className":"fs--26 w--600"}} button={{"page":"/kontakt","content":"Kontaktovat","section":"uvod","className":"btn-box btn-box--shape4 fs--18"}} layout={"3"} social={{"twitter":"saywebpage","facebook":"saywebpage","instagram":"saywebpage"}} transparent={true} />
)
}